import { Link } from "react-router";
import type { RunDTO } from "@roomate/core";
import { isFallbackRun, runtimeLabel } from "../lib/run-runtime.ts";

const FALLBACK_TITLE = "Took over from a run on another runtime";
const FALLBACK_CLS = "rounded-full bg-signal/10 px-2 py-0.5 text-[11px] text-signal";

/** The CLI a run used, plus a "Fallback" badge when it took over from a superseded run. Renders nothing for old rows. */
export function RunRuntime({ run, link = false }: { run: Pick<RunDTO, "runtime" | "fallbackFrom">; link?: boolean }) {
  const label = runtimeLabel(run);
  const fallback = isFallbackRun(run);
  if (!label && !fallback) return null;
  return (
    <span className="inline-flex items-center gap-1.5" data-testid="run-runtime">
      {label && (
        <span className="rounded-full bg-ink/[0.06] px-2 py-0.5 text-[11px] text-ink-2" data-testid="run-runtime-label">
          {label}
        </span>
      )}
      {fallback &&
        (link ? (
          <Link to={`/runs/${encodeURIComponent(run.fallbackFrom ?? "")}`} className={`${FALLBACK_CLS} hover:underline`} title={FALLBACK_TITLE} data-testid="run-fallback-badge">
            Fallback
          </Link>
        ) : (
          <span className={FALLBACK_CLS} title={FALLBACK_TITLE} data-testid="run-fallback-badge">
            Fallback
          </span>
        ))}
    </span>
  );
}
